const Color = () =>
  import(
    /* webpackChunkName: "base-info-featurec-olor" */ '@/pages/base-info/feature/color/index.vue'
  )
const CreateColor = () =>
  import(
    /* webpackChunkName: "base-info-featurec-olor" */ '@/pages/base-info/feature/color/create.vue'
  )
const EditColor = () =>
  import(
    /* webpackChunkName: "base-info-feature-color" */ '@/pages/base-info/feature/color/edit.vue'
  )

export default {
  path: 'color',
  meta: {
    label: 'color',
    auth: 'color'
  },
  component: {
    name: 'Color',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoFeatureColor',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Color
    },
    {
      name: 'BaseInfoCreateFeatureColor',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateColor
    },
    {
      name: 'BaseInfoEditFeatureColor',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditColor,
      props: true
    }
  ]
}
